<template>
  <div class="order-card">
    <div class="order-card-header">
      <div class="order-card-header-left">
        <img
          :src="cardIcon"
          alt=""
          class="order-card-img"
        >
        {{ `${value.productAmountYuan || 0}元 ${value.specialPackageName || getChargeCouponType(value.chargeCouponType)}` }}
      </div>
      <div class="order-card-header-right">{{ value.buyNum || 0 }}张</div>
    </div>
    <div class="order-card-body">
      <div class="order-card-body-info">
        <div class="order-card-body-info-label">充值账号：</div>
        <div class="order-card-body-info-text">{{ value.chargePhone || '' }}</div>
      </div>
      <div class="order-card-body-info">
        <div class="order-card-body-info-label">订单编号：</div>
        <div class="order-card-body-info-text">{{ value.orderNo || '' }}</div>
      </div>
      <div class="order-card-body-info">
        <div class="order-card-body-info-label">购买时间：</div>
        <div class="order-card-body-info-text">{{ value.payTime || '' }}</div>
      </div>
      <div class="order-card-body-value">
        实付<span class="number">{{ payAmount || 0 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import IconXJCD from '@/assets/img/chargingVoucher/logo-xjcd.png';
import IconTLD from '@/assets/img/chargingVoucher/logo-tld.png';
import IconXXCD from '@/assets/img/chargingVoucher/logo-xxcd.png';

const chargeCouponTypeOptions = [
  {
    id: 356838,
    key: 'SERVICE_OFF',
    name: '充电券类型',
    value: '服务费抵扣券'
  },
  {
    id: 356839,
    key: 'PAY_OFF',
    name: '充电券类型',
    value: '服务费+电费通抵券'
  }
];

export default {
  name: 'OrderCard',
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    cardIcon() {
      if (this.value.providerCompanyNo === 'TELD') {
        return IconTLD;
      }
      if (this.value.providerCompanyNo === 'XIAOJU') {
        return IconXJCD;
      }
      if (this.value.providerCompanyNo === 'XXCD') {
        return IconXXCD;
      }
      return IconXJCD;
    },
    payAmount() {
      let number = 0;
      let unit = '';
      // 微信支付
      if (this.value.chargePayType === 'WECHAT_PAY') {
        number = Number(this.value.payAmountYuan || 0);
        unit = '元';
      }
      // 积分支付
      if (this.value.chargePayType === 'SCORE_PAY') {
        number = Number(Number((this.value.payAmountYuan || 0) * 100).toFixed(2));
        unit = '积分';
      }
      return `${number}${unit}`;
    }
  },
  methods: {
    getChargeCouponType(key) {
      const option = chargeCouponTypeOptions.find(item => item.key === key);
      return option?.value || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.order-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 32px;
  width: 100%;
  margin-bottom: 16px;
  box-sizing: border-box;

  .order-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    .order-card-header-left {
      font-size: 32px;
      color: #383838;
      font-weight: bold;
      line-height: 45px;
      display: flex;
      align-items: center;

      .order-card-img {
        width: 48px;
        height: 48px;
        object-fit: contain;
        margin-right: 4px;
      }
    }
    .order-card-header-right {
      font-size: 32px;
      color: #646464;
      font-weight: 400;
      line-height: 45px;
    }
  }
  .order-card-body {
    padding-left: 52px;

    .order-card-body-info {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .order-card-body-info-label {
        font-size: 24px;
        color: #999999;
        letter-spacing: 0.36px;
        font-weight: 400;
        line-height: 33px;
      }
      .order-card-body-info-text {
        font-size: 24px;
        color: #383838;
        letter-spacing: 0.36px;
        font-weight: 400;
        line-height: 33px;
      }
    }
    .order-card-body-value {
      font-size: 24px;
      color: #383838;
      font-weight: 400;

      & .number {
        font-size: 32px;
        color: #fe7256;
        font-weight: bold;
        line-height: 45px;
      }
    }
  }
}
</style>
